import { lazy } from 'react';

export const CheckEmail = lazy(() =>
  import('./pages/auth/check_email').then((module) => ({
    default: module.CheckEmail,
  })),
);

export const LogIn = lazy(() =>
  import('./pages/auth/log_in').then((module) => ({ default: module.LogIn })),
);

export const SignUp = lazy(() =>
  import('./pages/auth/sign_up').then((module) => ({ default: module.SignUp })),
);

export const Confirmation = lazy(() =>
  import('./pages/auth/confirmation').then((module) => ({
    default: module.Confirmation,
  })),
);

export const ForgotPassword = lazy(() =>
  import('./pages/auth/forgot_password').then((module) => ({
    default: module.ForgotPassword,
  })),
);

export const EditPassword = lazy(() =>
  import('./pages/auth/edit_password').then((module) => ({
    default: module.EditPassword,
  })),
);

export const ClientSubscriptions = lazy(() =>
  import('./pages/client_subscriptions').then((module) => ({
    default: module.ClientSubscriptionsShow,
  })),
);

export const ClientDashboard = lazy(() =>
  import('./pages/dashboard').then((module) => ({
    default: module.ClientDashboard,
  })),
);

export const MyBookings = lazy(() =>
  import('./pages/my_bookings/show').then((module) => ({
    default: module.MyBookings,
  })),
);

export const MySubscription = lazy(() =>
  import('./pages/my_subscription/show').then((module) => ({
    default: module.MySubscription,
  })),
);

export const SubscriptionsPage = lazy(() =>
  import('./pages/subscriptions/show').then((module) => ({
    default: module.SubscriptionsPage,
  })),
);

export const TicketsPage = lazy(() =>
  import('./pages/tickets/show').then((module) => ({
    default: module.TicketsPage,
  })),
);

export const TicketPage = lazy(() =>
  import('./pages/tickets/[id]/show').then((module) => ({
    default: module.TicketPage,
  })),
);

export const CardsPage = lazy(() =>
  import('./pages/catalog/cards/show').then((module) => ({
    default: module.CardsPage,
  })),
);

export const CardPage = lazy(() =>
  import('./pages/catalog/cards/[id]/show').then((module) => ({
    default: module.CardPage,
  })),
);

export const SubscriptionCardsPage = lazy(() =>
  import('./pages/catalog/subscription_cards/show').then((module) => ({
    default: module.SubscriptionCardsPage,
  })),
);

export const SubscriptionCardPage = lazy(() =>
  import('./pages/catalog/subscription_cards/[id]/show').then((module) => ({
    default: module.SubscriptionCardPage,
  })),
);

export const ClientSubscriptionPage = lazy(() =>
  import('./pages/catalog/client_subscription/show').then((module) => ({
    default: module.ClientSubscriptionPage,
  })),
);

export const CertificatesPage = lazy(() =>
  import('./pages/catalog/certificates/show').then((module) => ({
    default: module.CertificatesPage,
  })),
);

export const CertificatePage = lazy(() =>
  import('./pages/catalog/certificates/[id]/show').then((module) => ({
    default: module.CertificatePage,
  })),
);

export const ClientCertificatesPage = lazy(() =>
  import('./pages/catalog/client_certificates/show').then((module) => ({
    default: module.ClientCertificatesPage,
  })),
);

export const ClientCertificatePage = lazy(() =>
  import('./pages/catalog/client_certificates/[id]/show').then((module) => ({
    default: module.ClientCertificatePage,
  })),
);

export const OnlineCertificatesPage = lazy(() =>
  import('./pages/online_certificates/show').then((module) => ({
    default: module.OnlineCertificatesPage,
  })),
);

export const OnlineCertificatePage = lazy(() =>
  import('./pages/online_certificates/[id]/show').then((module) => ({
    default: module.OnlineCertificatePage,
  })),
);

export const SubscriptionPage = lazy(() =>
  import('./pages/subscriptions/[id]/show').then((module) => ({
    default: module.SubscriptionPage,
  })),
);

export const BookingTypesPage = lazy(() =>
  import('./pages/booking/show').then((module) => ({
    default: module.BookingTypesPage,
  })),
);

export const BookingLayout = lazy(() =>
  import('./layouts/BookingLayout').then((module) => ({
    default: module.BookingLayout,
  })),
);

// Shared booking components
export const ClientBookingConfirmation = lazy(() =>
  import('./pages/booking/confirmation/show').then((module) => ({
    default: module.ClientBookingConfirmationPage,
  })),
);

// Time booking
export const ClientBookingLocationsPage = lazy(() =>
  import('./pages/booking/time/locations/show').then((module) => ({
    default: module.ClientBookingTimeLocationsPage,
  })),
);

export const ClientBookingServicesPage = lazy(() =>
  import('./pages/booking/time/services/show').then((module) => ({
    default: module.ClientBookingTimeServicesPage,
  })),
);

export const ClientBookingProviders = lazy(() =>
  import('./pages/booking/time/providers/show').then((module) => ({
    default: module.ClientBookingTimeProvidersPage,
  })),
);

export const ClientBookingPeriods = lazy(() =>
  import('./pages/booking/time/periods/show').then((module) => ({
    default: module.ClientBookingTimePeriodsPage,
  })),
);

// Class booking
export const ClientBookingClassesLocations = lazy(() =>
  import('./pages/booking/class/locations/show').then((module) => ({
    default: module.ClientBookingClassLocationsPage,
  })),
);

export const ClientBookingClasses = lazy(() =>
  import('./pages/booking/class/classes/show').then((module) => ({
    default: module.ClientBookingClassesPage,
  })),
);

// Event booking
export const ClientUpcomingEvents = lazy(() =>
  import('./pages/booking/event/events/show').then((module) => ({
    default: module.ClientBookingEventsPage,
  })),
);

// Booking v2 — the parallel client online-booking flow (SS-1287). It shares no
// route, component or localization entry with the legacy booking pages above.
export const ClientBooking = lazy(() =>
  import('./pages/online_booking').then((module) => ({
    default: module.ClientBooking,
  })),
);

export const ClientReservations = lazy(() =>
  import('./pages/client_reservations').then((module) => ({
    default: module.ClientReservations,
  })),
);
